import { type Dispatch, useCallback, useEffect, useState } from 'react';

export const useAbortController = <T extends AbortController>(initialController?: T): [T | undefined, Dispatch<T>] => {
  const [controller, setController] = useState(initialController);
  useEffect(() => () => controller?.abort(), [controller]);
  return [controller, useCallback(next => setController(prev => (prev && prev.abort()) || next), [])];
};
